<template>
  <div class="sidebar">
    <slot name="content" />

    <slot name="chat">
      <div v-if="chat" class="chat-help">
        <img class="chat-image" :src="geertImage" width="64">
        <div class="chat-info">
          <div class="title">
            Hulp nodig?
          </div>
          <div class="chat-hook positive" @click="openChatProxy">
            <span class="bold">chat</span> open tot 22:00
          </div>
        </div>
      </div>
      <div v-show="!chat" class="expert">
        <span class="expert-image">
          <img width="64" height="64" :src="geertImage">
        </span>
        <div class="expert-info">
          <div class="name">
            Geert
          </div>
          <div class="label">
            Energie-expert
          </div>
        </div>
      </div>

    </slot>
    <slot name="usps"></slot>
    <slot name="trophies">
      <div v-if="trophies" class="trophies">
        <div class="trophy thuiswinkel">
          <img class="trophy-icon" width="64" height="64" :src="thuiswinkelLogo">
          <div class="trophy-content">
            <span class="title"> Thuiswinkel partner</span>
            <span> sinds 2017 </span>
          </div>
        </div>
        <div class="trophy kiyoh">
          <img class="trophy-icon" width="64" height="64" :src="googleLogo">
          <div class="trophy-content">
            <span class="title">Beoordeeld met een <strong>9,3</strong></span>
            <span>door 300+ gebruikers</span>
          </div>
        </div>

        <div class="trophy gazellen">
          <img class="trophy-icon" :src="fdGazelle" width="60" height="60">
          <div class="trophy-content">
            <span class="title">
              FD Gazellen winnaars
            </span>
            <span>5 jaar op rij!</span>
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { openChat } from '../../../../assets/js/helpers/chat';

defineProps({
  trophies: Boolean,
  chat: Boolean,
});

const kiyoh = {
  percentageRecommendation: '93',
  reviewUrl: 'iets',
};

const geertImage = computed(() => '/assets/people/Geert-expert.png');
const thuiswinkelLogo = computed(() => '/assets/vectors/thuiswinkel-logo.svg');
const googleLogo = computed(() => '/assets/external/google-favicon.svg');
const fdGazelle = computed(() => '/assets/vectors/fd-gazellen.svg');

function openChatProxy(e) {
  openChat(e.currentTarget);
}
</script>

<style lang="scss">
@use 'assets/scss/all' as *;

.sidebar {
  line-height: 150%;
  padding: 0 16px;
  width: 100%;

  border-top: 1px solid #C4E3ED;
  display: none;

  @include breakpoint-up(xl) {
    display: block;
    padding: 0 24px;
    margin-top: 40px;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
    border-top: 0;
  }

  @include breakpoint-up(xl) {
    padding: unset;
    margin-top: unset;
    background-color: unset;
  }

  .sidebar-title {
    @include header-18;
    margin-bottom: 12px;
  }

  h5 {
    margin-bottom: 8px;
    text-align: left;
    font-weight: 600;
  }

  h6 {
    font-weight: 600;
    margin-bottom: 0;
  }

  .tip-text {
    @include paragraph-15;
    display: inline-block;

    +.tip-text {
      margin-top: 16px;
    }
  }

  .sidebar-card+.sidebar-card {
    margin-top: 24px;
  }

  hr {
    margin: 16px 0;
  }

  .chat-hook {
    font-weight: 600;
    color: $green-50;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
      color: $green-80;
    }
  }

  .chat-times {
    @include flex-row-start;

    cursor: pointer;
    font-weight: 500;
    color: $green-50;
    margin-top: 24px;

    .icon-element {
      background-color: currentColor;
      margin-right: 8px;
    }
  }

  .tip {
    border-radius: 16px;
    color: $text-subtle;
    margin-bottom: 24px;
  }

  .expert {
    @include flex-row;

    margin-bottom: 24px;
    align-items: center;
  }

  .expert-image {
    @include flex-col-center();

    width: 66px;

    img {
      width: 100%;
    }
  }

  .expert-info {
    margin-left: 16px;

    .name {
      @include header-18;
    }
  }

  .trophy,
  .chat-help {
    @include flex-row-start;
  }

  .chat-image,
  .trophy-icon {
    width: 40px;
    object-fit: contain;
    margin-right: 12px;
  }

  .chat-info,
  .trophy-content {
    @include flex-col-start;
  }

  .positive {
    color: $green-50;
  }

  .bold {
    font-weight: 600;
  }

  //chat
  .chat-help {
    margin: 24px 0;

    .title {
      font-size: 24px;
      line-height: 140%;
      font-weight: 600;
    }
  }

  // Trophies
  .trophies {
    display: grid;
    row-gap: 16px;
    padding: 24px 0;
    border-top: 1px solid $border-base;

    .title {
      font-size: 18px;
      font-weight: 600;
    }

    a {
      color: $text-base;
      font-weight: 600;
    }
  }
}
</style>
